import { useLocation, useSearchParams } from 'react-router-dom';
import { useCallback, useEffect, useState } from 'react';
import { request, toast } from '../../utils';
// import { OPDBillingPDF } from './options/Hospital/HMS/OPDBillingPDF';
// import { IPDBillingPDF } from './options/Hospital/HMS/IPDBillingPDF';
// import { PatientRegisterationPDF } from './options/Hospital/HMS/PatientRegisterationPDF';
import * as HospitalHMS from './options/Hospital/HMS';
import * as HospitalLIS from './options/Hospital/LIS';
import * as HospitalDoctorWorkBench from './options/Hospital/DoctorWorkBench';
import * as HospitalPharmacy from './options/Hospital/Pharmacy';
import * as GeneralLedger from './options/Hospital/GeneralLedger';
import * as HospitalRadiology from './options/Hospital/Radiology';
import * as HospitalIVF from "./options/Hospital/IVF"
import * as HospitalStoreManagement from "./options/Hospital/StoreManagement"
import * as HospitalTPA from "./options/Hospital/TPA"
import * as HospitalPhysiotherapy from "./options/Hospital/Physiotherapy"

const getPathMode = (path = '') => {
  return path
    .replace('/public', '')
    .replace('/print/', '')
    .split('/')
    .filter(Boolean)
    .join('.');
};

const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null;
const printOption = user ? user.printOption : 0;

const getDynamicComponent = (printoption) => {
  switch (printoption) {
    case 1:
      return HospitalHMS.PatientRegistrationPdf2;
    case 2:
      return HospitalHMS.PatientRegisterationPDF;
    case 3:
      return HospitalHMS.PatientRegistrationPdf3;
    case 4:
      return HospitalHMS.PatientRegistrationPdf4;
    case 5:
      return HospitalHMS.PatientRegisterationPdf6;
    case 6:
      return HospitalHMS.PatientRegistrationPdf7;
    case 7:
      return HospitalHMS.PatientRegistrationPdf8;
    case 8:
      return HospitalHMS.PatientRegistrationPdf9;
    case 9:
      return HospitalHMS.PatientRegistrationPdf10;
    case 10:
      return HospitalHMS.PatientRegisterationPdf11;
    case 11:
      return HospitalHMS.PatientRegisterationPdf12;
    case 12:
      return HospitalHMS.PatientRegisterationPdf13;
    case 13:
      return HospitalHMS.PatientRegistrationPdf14;
    case 14:
      return HospitalHMS.PatientRegistrationPdf15;
    case 15:
      return HospitalHMS.PatientRegistrationPdf16;
    case 16:
      return HospitalHMS.PatientRegistrationPdf17;
    case 17:
      return HospitalHMS.PatientRegistrationPdf18;
    case 18:
      return HospitalHMS.PatientRegistrationPdf19;
    case 19:
      return HospitalHMS.PatientRegistrationPdf20;
    case 20:
      return HospitalHMS.PatientRegistrationPdf21;
    case 21:
      return HospitalHMS.PatientRegistrationPdf22;
    case 22:
      return HospitalHMS.PatientRegistrationPdf23;
    case 23:
      return HospitalHMS.PatientRegistrationPdf24;
    case 24:
      return HospitalHMS.PatientRegistrationPdf25;
    case 25:
      return HospitalHMS.PatientRegistrationPdf26;
    default:
      return HospitalHMS.PatientRegistrationPdf1;
  }
};

const moduleLookup = {
  'hospital.outpatient-management.opd-billing': ({ data, isPublic }) => <HospitalHMS.OPDBillingPDF data={data} isPublic={isPublic} />,
  'hospital.health-checkup.opd-billing': ({ data, isPublic }) => <HospitalHMS.OPDBillingPDF data={data} isPublic={isPublic} />,
  'hospital.inpatient-management.indoor-service': ({ data, isPublic }) => <HospitalHMS.IPDBillingPDF data={data} isPublic={isPublic} />,

  'hospital.patient-admission.invoice-print': ({ data, isPublic }) => <HospitalHMS.PatientRegistrationInvoicePrint data={data} isPublic={isPublic} />,
  'hospital.patient-admission.emergency-print': ({ data, isPublic }) => <HospitalHMS.PatientRegistrationPdf5 data={data} isPublic={isPublic} />,
  'hospital.outpatient-management.patient-registeration.emergency-print': ({ data, isPublic }) => (
    <HospitalHMS.PatientRegistrationPdf5 data={data} isPublic={isPublic} />
  ),
  'hospital.outpatient-management.patient-registeration.invoice-print': ({ data, isPublic }) => (
    <HospitalHMS.PatientRegistrationInvoicePrint data={data} isPublic={isPublic} />
  ),
  'hospital.inpatient-management.indoor-registeration': ({ data, isPublic }) => <HospitalHMS.IndoorRegisterationPDF data={data} isPublic={isPublic} />,
  'hospital.inpatient-management.indoor-registeration.print1': ({ data, isPublic }) => (
    <HospitalHMS.IndoorRegistrationReportPdfPrint1 data={data} isPublic={isPublic} />
  ),
  'hospital.inpatient-management.indoor-registeration.label': ({ data, isPublic }) => (
    <HospitalHMS.IndoorRegisterationLabelPrint data={data} isPublic={isPublic} />
  ),
  'hospital.inpatient-management.indoor-registeration.tsc-label': ({ data, isPublic }) => (
    <HospitalHMS.IndoorRegistrationTSCLabelPrint data={data} isPublic={isPublic} />
  ),
  'hospital.outpatient-management.collection-summary.ref-by-collection': ({ data, isPublic }) => <HospitalHMS.RefByCollectionSummaryReportPdf data={data} isPublic={isPublic} />,
  'hospital.outpatient-management.collection-summary': ({ data, isPublic }) => <HospitalHMS.CollectionSummaryReport data={data} isPublic={isPublic} />,
  'hospital.outpatient-management.collection-summary.user-wise': ({ data, isPublic }) => (
    <HospitalHMS.UserWiseCollectionSummaryPdf data={data} isPublic={isPublic} />
  ),
  'hospital.outpatient-management.appointment-register-report': ({ data, isPublic }) => (
    <HospitalHMS.AppointmentRegisterReport data={data} isPublic={isPublic} />
  ),
  'hospital.outpatient-management.opd-referral-report': ({ data, isPublic }) => (
    <HospitalHMS.OpdReferralReportPdf data={data} isPublic={isPublic} />
  ),
  'hospital.outpatient-management.service-collection-report': ({ data, isPublic }) => (
    <HospitalHMS.ServiceCollectionReportPdf data={data} isPublic={isPublic} />
  ),
  'hospital.patient-admission.collection-summary': ({ data, isPublic }) => <HospitalHMS.CollectionSummaryReport data={data} isPublic={isPublic} />,
  'hospital.patient-admission.collection-summary.ref-by-collection': ({ data, isPublic }) => <HospitalHMS.RefByCollectionSummaryReportPdf data={data} isPublic={isPublic} />,
  'hospital.patient-admission.collection-summary.user-wise': ({ data, isPublic }) => (
    <HospitalHMS.UserWiseCollectionSummaryPdf data={data} isPublic={isPublic} />
  ),
  'hospital.outpatient-management.registration-register': ({ data, isPublic }) => (
    <HospitalHMS.RegistrationRegisterReport data={data} isPublic={isPublic} />
  ),
  'hospital.outpatient-management.doctor-master-report': ({ data, isPublic }) => <HospitalHMS.DoctorMasterReportPdf data={data} isPublic={isPublic} />,
  'hospital.outpatient-management.service-master-report': ({ data, isPublic }) => <HospitalHMS.ServiceMasterReportPdf data={data} isPublic={isPublic} />,
  'hospital.outpatient-management.service-package-report': ({ data, isPublic }) => (
    <HospitalHMS.ServicePackageReportPdf data={data} isPublic={isPublic} />
  ),
  'hospital.outpatient-management.consultant-wise-opd': ({ data, isPublic }) => (
    <HospitalHMS.ConsultantWiseOpdReportPdf data={data} isPublic={isPublic} />
  ),
  'hospital.outpatient-management.department-wise-opd': ({ data, isPublic }) => (
    <HospitalHMS.DepartmentWiseOpdReportPdf data={data} isPublic={isPublic} />
  ),
  'hospital.outpatient-management.sponsor-wise-opd': ({ data, isPublic }) => <HospitalHMS.SponsorWiseOpdReportPdf data={data} isPublic={isPublic} />,
  'hospital.outpatient-management.opd-patient-ledger': ({ data, isPublic }) => <HospitalHMS.OpdPatientLedgerPdf data={data} isPublic={isPublic} />,
  'hospital.outpatient-management.doctor-wise-opd-procedure-reports': ({ data, isPublic }) => (
    <HospitalHMS.DoctorWiseOpdProceduresReportPdf data={data} isPublic={isPublic} />
  ),
  'hospital.outpatient-management.due-payment-register': ({ data, isPublic }) => (
    <HospitalHMS.DuePaymentRegisterReportPdf data={data} isPublic={isPublic} />
  ),
  'hospital.inpatient-management.indoor-billing-management': ({ data, isPublic }) => (
    <HospitalHMS.IndoorBillManagementReportPdf data={data} isPublic={isPublic} />
  ),
  'hospital.inpatient-management.patient-discharge': ({ data, isPublic }) => <HospitalHMS.PatientDischargePdf data={data} isPublic={isPublic} />,
  'hospital.inpatient-management.credit-register-report': ({ data, isPublic }) => <HospitalHMS.CreditRegisterReportPdf data={data} isPublic={isPublic} />,
  'hospital.inpatient-management.balance-register-report': ({ data, isPublic }) => <HospitalHMS.BalanceRegisterReport data={data} isPublic={isPublic} />,
  'hospital.inpatient-management.bill-register-report': ({ data, isPublic }) => <HospitalHMS.BillRegisterReport data={data} isPublic={isPublic} />,
  'hospital.hr-management.generate-salary-slip': ({ data, isPublic }) => <HospitalHMS.SalarySlipPdf data={data} isPublic={isPublic} />,
  'hospital.inpatient-management.discount-register-report': ({ data, isPublic }) => (
    <HospitalHMS.DiscountRegisterReportPdf data={data} isPublic={isPublic} />
  ),
  'hospital.inpatient-management.service-register-report': ({ data, isPublic }) => (
    <HospitalHMS.ServiceRegisterReportPdf data={data} isPublic={isPublic} />
  ),
  'hospital.inpatient-management.doctor-ledger': ({ data, isPublic }) => (
    <HospitalHMS.DoctorLedgerReportPdf data={data} isPublic={isPublic} />
  ),
  'hospital.inpatient-management.doctor-ledger.summary': ({ data, isPublic }) => (
    <HospitalHMS.DoctorLedgerSummaryReportPdf data={data} isPublic={isPublic} />
  ),
  'hospital.inpatient-management.refund-register': ({ data, isPublic }) => <HospitalHMS.RefundRegisterReportPdf data={data} isPublic={isPublic} />,
  'hospital.inpatient-management.collection-analysis-report': ({ data, isPublic }) => (
    <HospitalHMS.CollectionAnalysisReportPdf data={data} isPublic={isPublic} />
  ),
  'hospital.inpatient-management.consultant-revenue-analysis-report': ({ data, isPublic }) => (
    <HospitalHMS.ConsultantRevenueAnalysisReportPdf data={data} isPublic={isPublic} />
  ),
  'hospital.inpatient-management.discharge-summary': ({ data, isPublic }) => <HospitalHMS.DischargeSummaryPDF data={data} isPublic={isPublic} />,
  'hospital.doctor-management.discharge-summary': ({ data, isPublic }) => <HospitalHMS.DischargeSummaryPDF data={data} isPublic={isPublic} />,
  'hospital.inpatient-management.receipt-voucher': ({ data, isPublic }) => <HospitalHMS.ReceiptVoucherPdf data={data} isPublic={isPublic} />,
  'hospital.inpatient-management.payment-refund-voucher': ({ data, isPublic }) => <HospitalHMS.PaymentRefundVocuherPdf data={data} isPublic={isPublic} />,
  'hospital.inpatient-management.active-patient-reports': ({ data, isPublic }) => (
    <HospitalHMS.IpdActivePatientReportPdf data={data} isPublic={isPublic} />
  ),
  'hospital.inpatient-management.ipd-admission-register-reports': ({ data, isPublic }) => (
    <HospitalHMS.IpdAdmissionRegisterReportPdf data={data} isPublic={isPublic} />
  ),
  'hospital.inpatient-management.ipd-discharge-register': ({ data, isPublic }) => (
    <HospitalHMS.IpdPatientDischargeReportPdf data={data} isPublic={isPublic} />
  ),
  'hospital.inpatient-management.indoor-collection-register': ({ data, isPublic }) => (
    <HospitalHMS.IndoorCollectionRegisterReportPdf data={data} isPublic={isPublic} />
  ),
  'hospital.outpatient-management.scheme-allotment': ({ data, isPublic }) => <HospitalHMS.SchemeAllotmentPdf data={data} isPublic={isPublic} />,
  'hospital.laboratory.result-entry': ({ data, isPublic }) => <HospitalLIS.ResultEntryPdf data={data} isPublic={isPublic} />,
  'hospital.laboratory.result-entry.print1': ({ data, isPublic }) => <HospitalLIS.ResultEntryPdf1 data={data} isPublic={isPublic} />,
  'hospital.laboratory.daily-investigation-report': ({ data, isPublic }) => <HospitalLIS.DailyInvestigationReport data={data} isPublic={isPublic} />,
  'hospital.laboratory.investigation-booking': ({ data, isPublic }) => <HospitalLIS.InvestigationBookingPdf data={data} isPublic={isPublic} />,
  'hospital.laboratory.sample-collection-report': ({ data, isPublic }) => <HospitalLIS.SampleCollectionReportPdf data={data} isPublic={isPublic} />,
  'hospital.laboratory.Uhid-IPD-No-Wise-report': ({ data, isPublic }) => <HospitalLIS.UhidIPDNoWiseReportPdf data={data} isPublic={isPublic} />,
  'hospital.doctor-management.opd-requisition': ({ data, isPublic }) => <HospitalDoctorWorkBench.OpdRequisitionPdf data={data} isPublic={isPublic} />,
  'hospital.doctor-management.ipd-requisition': ({ data, isPublic }) => <HospitalDoctorWorkBench.IpdRequisitionPdf data={data} isPublic={isPublic} />,
  'hospital.opd-clinical-management.opd-requisition': ({ data, isPublic }) => (
    <HospitalDoctorWorkBench.OpdRequisitionPdf data={data} isPublic={isPublic} />
  ),
  'hospital.emr.opd-requisition': ({ data, isPublic }) => <HospitalDoctorWorkBench.OpdRequisitionPdf data={data} isPublic={isPublic} />,
  'hospital.doctor-management.opd-requisition.ProgressReport': ({ data, isPublic }) => (
    <HospitalDoctorWorkBench.OpdRequisitionProgressReportPdf data={data} isPublic={isPublic} />
  ),
  'hospital.doctor-management.ipd-requisition.ProgressReport': ({ data, isPublic }) => (
    <HospitalDoctorWorkBench.IpdRequisitionProgressReportPdf data={data} isPublic={isPublic} />
  ),
  'hospital.inpatient-management.sponsor-wise-ipd-report': ({ data, isPublic }) => (
    <HospitalHMS.SponsorWiseIpdReportPdf data={data} isPublic={isPublic} />
  ),
  'hospital.emr.opd-requisition.ProgressReport': ({ data, isPublic }) => (
    <HospitalDoctorWorkBench.OpdRequisitionProgressReportPdf data={data} isPublic={isPublic} />
  ),
  'hospital.inventory.retail-sale-pos': ({ data, isPublic }) => <HospitalPharmacy.RetailSalePosPDF data={data} isPublic={isPublic} />,
  'hospital.tally.gst-report': ({ data, isPublic }) => <GeneralLedger.GstReportPdf data={data} isPublic={isPublic} />,
  'hospital.inventory.gst-report': ({ data, isPublic }) => <HospitalPharmacy.GstReportPdf data={data} isPublic={isPublic} />,
  'hospital.inventory.batch-wise-expired-item': ({ data, isPublic }) => (
    <HospitalPharmacy.BatchWiseExpriredItemReportPdf data={data} isPublic={isPublic} />
  ),
  'hospital.inventory.batch-wise-near-expiring-item': ({ data, isPublic }) => (
    <HospitalPharmacy.BatchWiseExpriredItemReportPdf data={data} isPublic={isPublic} />
  ),
  'hospital.inventory.stock-status': ({ data, isPublic }) => <HospitalPharmacy.StockStatusReportPdf data={data} isPublic={isPublic} />,
  'hospital.inventory.stock-status.group': ({ data, isPublic }) => <HospitalPharmacy.StockStatusReportPdf data={data} isPublic={isPublic} />,
  'hospital.inventory.stock-status.subgroup': ({ data, isPublic }) => <HospitalPharmacy.StockStatusReportPdf data={data} isPublic={isPublic} />,
  'hospital.inventory.stock-status.category': ({ data, isPublic }) => <HospitalPharmacy.StockStatusReportPdf data={data} isPublic={isPublic} />,
  'hospital.inventory.stock-status.salt': ({ data, isPublic }) => <HospitalPharmacy.StockStatusReportPdf data={data} isPublic={isPublic} />,

  'hospital.inventory.item-wise-sale-reort-register': ({ data, isPublic }) => (
    <HospitalPharmacy.ItemWiseSaleReortRegisterPdf data={data} isPublic={isPublic} />
  ),
  'hospital.inventory.grn-report': ({ data, isPublic }) => <HospitalPharmacy.GrnPdf data={data} isPublic={isPublic} />,
  'hospital.inventory.product-master-report': ({ data, isPublic }) => <HospitalPharmacy.ProductMasterReportPdf data={data} isPublic={isPublic} />,
  'hospital.inventory.product-master-report-excel': ({ data, isPublic }) => (
    <HospitalPharmacy.ProductMasterReportExcelPdf data={data} isPublic={isPublic} />
  ),
  'hospital.inventory.product-ledger': ({ data, isPublic }) => <HospitalPharmacy.ProductLedgerPdf data={data} isPublic={isPublic} />,
  'hospital.inventory.product-ledger.group': ({ data, isPublic }) => <HospitalPharmacy.ProductLedgerPdf data={data} isPublic={isPublic} />,
  'hospital.inventory.product-ledger.subgroup': ({ data, isPublic }) => <HospitalPharmacy.ProductLedgerPdf data={data} isPublic={isPublic} />,
  'hospital.inventory.product-ledger.category': ({ data, isPublic }) => <HospitalPharmacy.ProductLedgerPdf data={data} isPublic={isPublic} />,
  'hospital.inventory.product-ledger.salt': ({ data, isPublic }) => <HospitalPharmacy.ProductLedgerPdf data={data} isPublic={isPublic} />,

  'hospital.inventory.indent-medicine-issue': ({ data, isPublic }) => <HospitalPharmacy.IndentMedicineIssueReportPdf data={data} isPublic={isPublic} />,
  'hospital.inventory.product-tracking-report': ({ data, isPublic }) => <HospitalPharmacy.ProductTrackingReportPdf data={data} isPublic={isPublic} />,
  'hospital.inventory.purchase-requisition-report': ({ data, isPublic }) => (
    <HospitalPharmacy.PurchaseRequisitionReportPdf data={data} isPublic={isPublic} />
  ),
  'hospital.inventory.purchase-order-report': ({ data, isPublic }) => <HospitalPharmacy.PurchaseOrderReportPdf data={data} isPublic={isPublic} />,
  'hospital.inventory.purchase-summary': ({ data, isPublic }) => <HospitalPharmacy.PurchaseSummaryPdf data={data} isPublic={isPublic} />,
  'hospital.inventory.purchase-return-report': ({ data, isPublic }) => <HospitalPharmacy.PurchaseReturnReportPdf data={data} isPublic={isPublic} />,
  'hospital.inventory.stock-transfer-request-report': ({ data, isPublic }) => (
    <HospitalPharmacy.StockTransferRequestReportPdf data={data} isPublic={isPublic} />
  ),
  'hospital.inventory.stock-transfer-report': ({ data, isPublic }) => <HospitalPharmacy.StockTransferReportPdf data={data} isPublic={isPublic} />,
  'hospital.inventory.stock-transfer-accept-report': ({ data, isPublic }) => (
    <HospitalPharmacy.StockTransferAcceptReportPdf data={data} isPublic={isPublic} />
  ),
  'hospital.inventory.stock-transfer-form': ({ data, isPublic }) => <HospitalPharmacy.StockTransferFormPdf data={data} isPublic={isPublic} />,
  'hospital.inventory.stock-adjutment-report': ({ data, isPublic }) => <HospitalPharmacy.StockAdjutmentReportsPdf data={data} isPublic={isPublic} />,
  'hospital.inventory.warehouse-report': ({ data, isPublic }) => <HospitalPharmacy.WerehouseReportPdf data={data} isPublic={isPublic} />,
  'hospital.inventory.batch-wise-item-transaction': ({ data, isPublic }) => (
    <HospitalPharmacy.BatchWiseItemTransactionPdf data={data} isPublic={isPublic} />
  ),
  'hospital.inventory.location-wise-stock-summary': ({ data, isPublic }) => (
    <HospitalPharmacy.LocationWiseStockSummaryPdf data={data} isPublic={isPublic} />
  ),
  'hospital.inventory.monthly-stock-movement-analysis': ({ data, isPublic }) => (
    <HospitalPharmacy.MonthlyStockMovementAnalysisPdf data={data} isPublic={isPublic} />
  ),
  'hospital.inventory.purchase-order': ({ data, isPublic }) => <HospitalPharmacy.PurchaseOrderPrintPdf data={data} isPublic={isPublic} />,
  'hospital.inventory.update-batch-no': ({ data, isPublic }) => <HospitalPharmacy.UpdateBatchNoPdf data={data} isPublic={isPublic} />,
  'hospital.radiology.radiology-status-report': ({ data, isPublic }) => <HospitalRadiology.RadiologyStatusReportPdf data={data} isPublic={isPublic} />,
  'hospital.nurse-module.room-status-report': ({ data, isPublic }) => <HospitalHMS.RoomStatusReportPdf data={data} isPublic={isPublic} />,

  'hospital.inpatient-management.indoor-billing-management.summary': ({ data, isPublic }) => (
    <HospitalHMS.IndoorBillManagementReportSummaryPdf data={data} isPublic={isPublic} />
  ),
  'hospital.inpatient-management.indoor-billing-management.summary1': ({ data, isPublic }) => (
    <HospitalHMS.IndoorBillManagementReportSummaryPdf1 data={data} isPublic={isPublic} />
  ),
  'hospital.inpatient-management.indoor-billing-management.summary2': ({ data, isPublic }) => (
    <HospitalHMS.IndoorBillManagementSummaryPdf2 data={data} isPublic={isPublic} />
  ),
  'hospital.inpatient-management.indoor-billing-management.detail': ({ data, isPublic }) => (
    <HospitalHMS.IndoorBillManagementReportPdf data={data} isPublic={isPublic} />
  ),
  'hospital.inpatient-management.indoor-billing-management.detail1': ({ data, isPublic }) => (
    <HospitalHMS.IndoorBillManagementDetail1ReportPdf data={data} isPublic={isPublic} />
  ),
  'hospital.inpatient-management.indoor-billing-management.group': ({ data, isPublic }) => (
    <HospitalHMS.IndoorBillManagementGroupReportPdf data={data} isPublic={isPublic} />
  ),
  'hospital.diet-management.diet-report': ({ data, isPublic }) => (
    <HospitalHMS.DietReportPdf data={data} isPublic={isPublic} />
  ),
  'hospital.ot.ot-entry-register': ({ data, isPublic }) => (
    <HospitalHMS.OtEntryRegisterPdf data={data} isPublic={isPublic} />
  ),
  'hospital.ot.ot-schedule-register': ({ data, isPublic }) => (
    <HospitalHMS.OtScheduleRegisterPdf data={data} isPublic={isPublic} />
  ),
  'hospital.blood-bank.blood-request-status-report': ({ data, isPublic }) => (
    <HospitalHMS.BloodRequestStatusReportPdf data={data} isPublic={isPublic} />
  ),
  'hospital.blood-bank.donor-master-report': ({ data, isPublic }) => (
    <HospitalHMS.DonorMasterReportPdf data={data} isPublic={isPublic} />
  ),
  'hospital.blood-bank.intake-blood-report': ({ data, isPublic }) => (
    <HospitalHMS.IntakeBloodReportPdf data={data} isPublic={isPublic} />
  ),
  'hospital.mis-report.collection-summary': ({ data, isPublic }) => <HospitalHMS.CollectionSummaryReport data={data} isPublic={isPublic} />,
  'hospital.mis-report.collection-summary.user-wise': ({ data, isPublic }) => (
    <HospitalHMS.UserWiseCollectionSummaryPdf data={data} isPublic={isPublic} />
  ),
  'hospital.mis-report.consultant-revenue-analysis-report': ({ data, isPublic }) => (
    <HospitalHMS.ConsultantRevenueAnalysisReportPdf data={data} isPublic={isPublic} />
  ),
  'hospital.mis-report.service-register-report': ({ data, isPublic }) => (
    <HospitalHMS.ServiceRegisterReportPdf data={data} isPublic={isPublic} />
  ),
  'hospital.mis-report.refund-register': ({ data, isPublic }) => <HospitalHMS.RefundRegisterReportPdf data={data} isPublic={isPublic} />,
  'hospital.mis-report.credit-register-report': ({ data, isPublic }) => <HospitalHMS.CreditRegisterReportPdf data={data} isPublic={isPublic} />,
  'hospital.mis-report.balance-register-report': ({ data, isPublic }) => <HospitalHMS.BalanceRegisterReport data={data} isPublic={isPublic} />,
  'hospital.mis-report.discount-register-report': ({ data, isPublic }) => (
    <HospitalHMS.DiscountRegisterReportPdf data={data} isPublic={isPublic} />
  ),
  'hospital.mis-report.collection-analysis-report': ({ data, isPublic }) => (
    <HospitalHMS.CollectionAnalysisReportPdf data={data} isPublic={isPublic} />
  ),
  'hospital.mis-report.doctor-ledger': ({ data, isPublic }) => (
    <HospitalHMS.DoctorLedgerReportPdf data={data} isPublic={isPublic} />
  ),
  'hospital.mis-report.indoor-collection-register': ({ data, isPublic }) => (
    <HospitalHMS.IndoorCollectionRegisterReportPdf data={data} isPublic={isPublic} />
  ),
  'hospital.doctor-management.doctor-ledger-report': ({ data, isPublic }) => (
    <HospitalHMS.DoctorLedgerReportPdf data={data} isPublic={isPublic} />
  ),
  'hospital.doctor-management.view-doctor-visits-and-bills': ({ data, isPublic }) => (
    <HospitalDoctorWorkBench.ViewDoctorVisitsAndBillsPdf data={data} isPublic={isPublic} />
  ),
  'hospital.inpatient-management.view-doctor-visits-and-bills': ({ data, isPublic }) => (
    <HospitalDoctorWorkBench.ViewDoctorVisitsAndBillsPdf data={data} isPublic={isPublic} />
  ),
  'hospital.outpatient-management.doctor-ledger-report': ({ data, isPublic }) => (
    <HospitalHMS.DoctorLedgerReportPdf data={data} isPublic={isPublic} />
  ),
  'hospital.outpatient-management.doctor-ledger-report.summary': ({ data, isPublic }) => (
    <HospitalHMS.DoctorLedgerSummaryReportPdf data={data} isPublic={isPublic} />
  ),
  'hospital.labour-room.ivf-examination': ({ data, isPublic }) => (
    <HospitalIVF.IVFExaminationPdf data={data} isPublic={isPublic} />
  ),
  'hospital.labour-room.ivf-examination.progress-report': ({ data, isPublic }) => (
    <HospitalIVF.IVFProgressReportPdf data={data} isPublic={isPublic} />
  ),
  'hospital.labour-room.ivf-treatement': ({ data, isPublic }) => (
    <HospitalIVF.IVFTreatementPdf data={data} isPublic={isPublic} />
  ),
  'hospital.store-management.purchase-order': ({ data, isPublic }) => (
    <HospitalStoreManagement.StorePurchaseOrderPrintPdf data={data} isPublic={isPublic} />
  ),
  'hospital.radiology.radiology-service-acknowledgement': ({ data, isPublic }) => <HospitalRadiology.RadioServiceAcknowledgementPdf data={data} isPublic={isPublic} />,

  'hospital.radiology.radiology-service-booking': ({ data, isPublic }) => (
    <HospitalRadiology.RadiologyServiceBookingPdf data={data} isPublic={isPublic} />
  ),

  'hospital.physiotherapy.physiotherapy-booking': ({ data, isPublic }) => (
    <HospitalPhysiotherapy.PhysiotherapyBookingPdf data={data} isPublic={isPublic} />
  ),
  'hospital.physiotherapy.physiotherapy-booking-report': ({ data, isPublic }) => (
    <HospitalPhysiotherapy.PhysiotherapyBookingReportPdf data={data} isPublic={isPublic} />
  ),

  'hospital.inpatient-management.indoor-billing-management.receipt-voucher': ({ data, isPublic }) => (
    <HospitalHMS.AllReceiptVoucherPdf data={data} isPublic={isPublic} />
  ),
  'hospital.inventory.collection-summary': ({ data, isPublic }) => (
    <HospitalPharmacy.CollectionSummaryReportPdf data={data} isPublic={isPublic} />
  ),
  'hospital.radiology.radiology-service-booking-report': ({ data, isPublic }) => (
    <HospitalRadiology.RadiologyServiceBookingReportPdf data={data} isPublic={isPublic} />
  ),
  'hospital.inpatient-management.collection-summary': ({ data, isPublic }) => (
    <HospitalHMS.CollectionSummaryReport data={data} isPublic={isPublic} />
  ),
  'hospital.inpatient-management.collection-summary.user-wise': ({ data, isPublic }) => (
    <HospitalHMS.UserWiseCollectionSummaryPdf data={data} isPublic={isPublic} />
  ),
  'hospital.inventory.zero-stock-report': ({ data, isPublic }) => (
    <HospitalPharmacy.ZeroStockProductPdfReport data={data} isPublic={isPublic} />
  ),
  'hospital.inventory.credit-report': ({ data, isPublic }) => (
    <HospitalPharmacy.CreditPdfReport data={data} isPublic={isPublic} />
  ),
  'hospital.tpa.tpa-claim-amount-status-report': ({ data, isPublic }) => (
    <HospitalTPA.TpaClaimAmountReportStatusPdf data={data} isPublic={isPublic} />
  ),
};



export const Print = ({ isPublic = false }) => {
  const { pathname, search } = useLocation();
  const [searchParams] = useSearchParams();
  const [data, setData] = useState();

  const getData = useCallback(
    async (path) => {
      const response = await request(path, { method: 'GET', query: { refId: searchParams.get('refId') } }, true);
      if (response?.success) {
        setData(response.data);
      } else {
        toast('Failed to load data', { variant: 'error' });
      }
    },
    [searchParams]
  );

  useEffect(() => {
    getData(pathname);
  }, [pathname, search, getData]);

  // Check if the current route is 'hospital.patient-registeration.patient-registeration'
  if (pathname === '/print/hospital/patient-admission' && data) {
    const DynamicComponent = getDynamicComponent(printOption);
    return <DynamicComponent data={data} isPublic={isPublic} />;
  }

  if (pathname === '/print/hospital/outpatient-management/patient-registeration' && data) {
    const DynamicComponent = getDynamicComponent(printOption);
    return <DynamicComponent data={data} isPublic={isPublic} />;
  }

  return (
    <>
      {data &&
        moduleLookup[getPathMode(pathname)]({
          data,
          isPublic
        })}
    </>
  )
};
